module.exports = __webpack_public_path__ + "img/emotions.6c8111cf.png";